import { CharacterHandler, StatusType } from "./characters";
import { GeneTrait } from "./genetics";
import { AgeType, WorldState } from "./world";

export type StatisticAgePoint<T> = {
  cycle: number;
  value: T;
};
export type StatisticState = {
  charactersTotal: StatisticAgePoint<number>[];
  deadsTotal: StatisticAgePoint<number>[];
  deadsPerCycle: StatisticAgePoint<number>[];
  deathCausesPerCycle: StatisticAgePoint<DeathCauseStat[]>[];
  ageMax: StatisticAgePoint<number>[];
  geneTraits: StatisticAgePoint<GeneStats[]>[];
  status: StatisticAgePoint<StatusStats[]>[];
};

type MultipleStat<T> = {
  type: T;
  value: number;
};

type DeathCauseStat = MultipleStat<StatusType>;
type GeneStats = MultipleStat<GeneTrait>;
type StatusStats = MultipleStat<StatusType>;

export const getStats = (
  w: WorldState,
  stats: StatisticState
): StatisticState => {
  const oldestChar = CharacterHandler.getOldest(w.characters);
  const { deadsPerCycle, deadsTotal } = stats;

  const newDeadNum =
    deadsTotal.length > 0
      ? w.deads.length - deadsTotal[deadsTotal.length - 1].value
      : w.deads.length;

  const newDeads = w.deads.slice(w.deads.length - newDeadNum, w.deads.length);

  if (newDeadNum !== newDeads.length) {
    console.log(newDeadNum, newDeads, w.deads);
  }

  const newDeadsByCauseNum: DeathCauseStat[] = [
    StatusType.STARVING,
    StatusType.OLD,
    StatusType.WOUNDED,
    StatusType.PREGNANT,
  ].map((s) => {
    const newDeadsByCause = newDeads.filter((c) =>
      c.statusList.find(
        (cs) => cs.type === StatusType.DEAD && cs.payload.cause.type === s
      )
    );

    return {
      type: s,
      value: newDeadsByCause?.length || 0,
    };
  });

  const geneTraitsNum: GeneStats[] = Object.values(GeneTrait).map(
    (geneTrait) => {
      return {
        type: geneTrait,
        value: w.characters.filter((c) =>
          c.genes.find((g) => g.trait === geneTrait)
        ).length,
      };
    }
  );

  const statusNum: StatusStats[] = Object.values(StatusType).map(
    (statusType) => {
      return {
        type: statusType,
        value: w.characters.filter((c) =>
          c.statusList.find((s) => s.type === statusType)
        ).length,
      };
    }
  );

  return {
    ...stats,
    charactersTotal: [
      ...stats.charactersTotal,
      {
        cycle: w.cycles,
        value: w.characters.length,
      },
    ],
    deadsTotal: [
      ...stats.deadsTotal,
      {
        cycle: w.cycles,
        value: w.deads.length,
      },
    ],
    deadsPerCycle: [
      ...stats.deadsPerCycle,
      {
        cycle: w.cycles,
        value: newDeadNum,
      },
    ],
    deathCausesPerCycle: [
      ...stats.deathCausesPerCycle,
      {
        cycle: w.cycles,
        value: newDeadsByCauseNum,
      },
    ],
    ageMax: [
      ...stats.ageMax,
      {
        cycle: w.cycles,
        value: oldestChar ? CharacterHandler.age(oldestChar, AgeType.YEAR) : 0,
      },
    ],
    geneTraits: [
      ...stats.geneTraits,
      {
        cycle: w.cycles,
        value: geneTraitsNum,
      },
    ],
    status: [
      ...stats.status,
      {
        cycle: w.cycles,
        value: statusNum,
      },
    ],
  };
};
